
function Footer() {
  function handleSubscribe() {
    alert("Thanks for subscribing!!!");
  }

  return (
    <>
      <footer style={{height:'120px', marginTop:'-90px'}}>
        <div className="container" >
          <div className="footer-content">
            <ul className="footer-content__2">
              <li>Contact Us</li>


              <li style={{ fontSize: "14px", fontWeight: "bold" }}>
                <a href="tel:+16493413819">&#x260E; +16493413819</a>
              </li>

              <li style={{ fontSize: "14px", fontWeight: "bold" }}>
                <a
                  href="mailto: 
                ayton85@hotmail.com"
                >
                  &#9993; ayton85@hotmail.com
                </a>
              </li>

              <li>
                <a
                  style={{ fontSize: "14px", fontWeight: "bold" }}
                  target="_blank"
                  rel="noreferrer"
                 // href="https://maps.app.goo.gl/gyo3oLjVkVEJomSi8"
                  // href="https://jephunneh.com/"
                >
                  &#128205; Leeward Palms, Hibiscus Ln, Leeward Settlement TKCA 1ZZ, Turks & Caicos Islands
                </a>
              </li>


            </ul>

            <ul className="footer-content__1">
              <li>
                <span style={{ color: "#B8860B" }}>Price Is Right ATV</span>
               
              </li>

              <li style={{ fontSize: "13px" }}>
                We're the best choice if you are looking to rent a atv in Turks & Caicos. We offer a range of atv vehicle along with tour packages to choose from.
              
              </li>

              <li>
                <a
                  style={{ fontSize: "14px" }}
                  target="_blank"
                  rel="noreferrer"
                  href="https://dev2code.com"
                >
                  <span>Website By:</span>
                </a>
              </li>

              <li>
                <a
                  style={{ fontSize: "14px" }}
                  target="_blank"
                  rel="noreferrer"
                 // href="https://needforwebsite.site"
                >
                  <span style={{ color: "#B8860B" }}>Qasim</span>
                </a>
              </li>
            </ul>

            <ul className="footer-content__2">
              <li>Company</li>
              <li>
                {/*<a   href="https://maps.app.goo.gl/gyo3oLjVkVEJomSi8"> 
                  Our Location
                </a> */}
              </li>
              <li>
                <a href="/">Careers</a>
              </li>
              <li>
                <a href="/">Mobile</a>
              </li>

              <li>
                <a
                  target="_blank"
                  rel="noreferrer"
                 // href="https://adminsleekrentals.netlify.app/"
                  //
                >
                  Admin &#128187;
                </a>
              </li>
            </ul>

            <ul className="footer-content__2">
              <li>Working Hours</li>
              <li>Mon - Sat: 9:00AM - 6:00PM</li>
              <li>Sun: 9:00am - 6:00 pm</li>
            </ul>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
